<section
  class="project-frame-page"
  [attr.aria-label]="project.name + ' website'"
  [attr.aria-busy]="showProjectLoader()"
>
  @if (showProjectLoader()) {
    <div class="project-loading-screen" aria-label="Loading project website">
      <div class="loader" aria-hidden="true"></div>
    </div>
  }

  <iframe
    class="project-site-frame"
    [src]="trustedProjectUrl"
    [title]="project.name + ' website'"
    loading="eager"
  ></iframe>
</section>
